import authHeader from './auth-header';
import { baseBackUrl } from "../assets/linkTree";

export default {
    baseURL: baseBackUrl + 'api',
    timeout: 1000,

    connData(extraConfig) {
        return {... {
                baseURL: process.env.baseURL || this.baseURL,
                headers: authHeader(),
            },
            ...extraConfig
        }
    }
};


// WEBPACK FOOTER //
// ./src/services/api.config.js